import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { guid } from "@app/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineConnectorPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineConnectorPage',
  setup(__props) {

    document.title = "Configure connector"

    const tid = useOrganizationUnitId()
    const id = useId()
    const { useCurrentUserQuery, useConnectorProvidersQuery, usePipelineDetailsQuery, useCreateConnectorCommand } = useAdminConfigurePipelineConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)
    const configPageUrl = computed(() => direction.value == 1 ? `${provider.value?.ReadConfigPageUrl}${tid}` : `${provider.value?.WriteConfigPageUrl}${tid}`)
    const connectorProviderType = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderType)
    const connectorConfig = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorConfig)

    const { runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1, canRead, canWrite } = useConnectorProvidersQuery()

    const { invokeCreateConnectorCommandV1, providerType, config, succeed } = useCreateConnectorCommand(null, tid, userId, name)

    const connectorId = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorId || guid())
    const providers = computed(() => modelConnectorProvidersQueryV1.value?.Providers)
    const provider = computed(() => providers.value?.find(_ => _.Type == providerType.value))

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(direction, (val) => {
        canRead.value = val == 1
        canWrite.value = val == 2
        runConnectorProvidersQueryV1()
    })

    watch(succeed, () => {
        if (succeed.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': connectorConfig.value
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeCreateConnectorCommandV1({ Id: connectorId.value })
            }
        }
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })

return { __sfc: true,tid, id, useCurrentUserQuery, useConnectorProvidersQuery, usePipelineDetailsQuery, useCreateConnectorCommand, connectorProviderElement, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, direction, name, configPageUrl, connectorProviderType, connectorConfig, runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1, canRead, canWrite, invokeCreateConnectorCommandV1, providerType, config, succeed, connectorId, providers, provider, onMessage }
}

})